export const container = (
    node: HTMLElement,
    sizes: { [k: string]: number } = {}
): { destroy: () => void } => {
    const ro = new ResizeObserver(() => {
        setTimeout(() => {
            const nodeSize = node.getBoundingClientRect().width;
            let activeClass = "";

            const sizesArr = Object.keys(sizes).map((key) => ({
                key: key,
                value: sizes[key],
            }));
            const sortedSizesArr = sizesArr.sort((a, b) => a.value - b.value);

            // clean up classes
            for (const size of sortedSizesArr) {
                node.classList.remove(size.key);
            }

            // find active class
            for (const size of sortedSizesArr) {
                if (nodeSize < size.value) {
                    activeClass = size.key;
                    break;
                }
            }

            if (activeClass) node.classList.add(activeClass);
        }, 0);
    });

    ro.observe(node);

    return {
        destroy() {
            ro.disconnect();
        },
    };
};
